import { useMemo } from "react";
import { MENU_LIST } from "../../components/SignInUp/helper";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useMatch, useNavigate } from "react-router";
import BalanceCard from "../Profile/components/balanceCard";
import UserLogout from "../../api/UserLogout";
import { notice } from "../../redux/action/action";
import {
  cleanMemberInfo,
  clearTransferWallet,
  storeVipDetail,
} from "../../redux/action/member/memberAction";
import { IoCloseOutline } from "react-icons/io5";
import { actionLogout } from "../../api/postApi";
import Cookies from "js-cookie";
import LoadingIcon from "../../components/Loading/LoadingIcon";
import { HiChevronRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { commonOpacity } from "../../animateConstant";
import { BiSolidUser } from "react-icons/bi";
import ProfileButton from "./components/profileButton";
import CustomerNameText from "./components/customerNameText";
import GoogleLogout from "../Singin/components/googleLogout";
import Copy from "../../components/CopyComponent/Copy";
import { clearFavoriteGameList } from "../../redux/action/game/gameAction";
import CommonConfirmModal from "../../components/Modal/commonConfirmModal";
import CachePop from "./components/cachePop";

const motionProps = {
  initial: commonOpacity.initial,
  animate: commonOpacity.animate,
  exit: commonOpacity.exit,
  transition: commonOpacity.transition,
};

const Aside = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { signOut } = GoogleLogout();

  const memberData = useSelector((state) => state.isMemberInfo);
  const cachePop = useSelector((state) => state.isCachePop);
  const dispatch = useDispatch();

  const MENU = MENU_LIST({ className: "!mr-0 text-[19px]", dispatch });

  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoutUser = () => {
    actionLogout().then((data) => {
      dispatch(notice(i18n("Logout Success"), "success", 7));
      signOut();
      UserLogout();
      dispatch(cleanMemberInfo());
      dispatch(clearFavoriteGameList());
      dispatch(clearTransferWallet());
      dispatch(storeVipDetail(window.vipDetails));
      navigate("/casino");
    });
  };

  return (
    <motion.section
      {...motionProps}
      className="flex flex-col gap-[3px] md:gap-[5px] overflow-y-scroll no-scrollbar h-full"
    >
      <div className="flex items-center md:justify-start justify-between md:py-[10px] pb-[10px]">
        <ProfileButton className="bg-base-light-white text-base-dark dark:bg-base-input-gray dark:text-base-white" />
        <div className="flex flex-col ml-[10px]">
          <CustomerNameText />
          <p className="text-light-text text-sm mb-0 flex items-center gap-[10px]">
            UID:{` `}
            <LoadingIcon>
              {memberData?.uid}
              <Copy copyLink={memberData?.uid} />
            </LoadingIcon>
          </p>
        </div>
        <div className="text-4xl text-light-text block md:hidden">
          <IoCloseOutline
            className="cursor-pointer"
            onClick={() => {
              navigate("../");
            }}
          />
        </div>
      </div>
      <div className="mb-[10px] md:hidden block">
        <BalanceCard />
      </div>
      <section className="flex flex-col gap-[1px]">
        {MENU.map((route) => {
          return (
            <div
              onClick={() => {
                if (route.func) {
                  route.func();
                  return;
                }
                if (route.hashed) {
                  navigate(`/${route.link}`);
                } else {
                  navigate(`../profile/${route.link}`);
                }
              }}
              className={`text-base-dark dark:text-base-white md:bg-transparent md:dark:bg-transparent hover:dark:bg-base-light-dark bg-base-light-white dark:bg-base-light-dark py-[7px] px-[12px] flex items-center justify-between hover:text-black font-medium hover:bg-[#FFFFFF]  rounded-lg cursor-pointer ${
                route.divider && "mb-[10px]"
              } ${route.className} ${
                location.pathname.includes(route.link) &&
                `!bg-base-light-white dark:!bg-base-light-dark text-black`
              } `}
            >
              <section className="flex items-center">
                <div
                  className={`h-[33px] w-[33px] flex items-center justify-center rounded-[5px] bg-black text-light-white`}
                  style={{ background: route.iconColor }}
                >
                  {route.icon}
                </div>
                <span className="ml-[10px]">
                  {i18n(route.text?.toLowerCase())}
                </span>
              </section>
              <HiChevronRight className="md:hidden" />
            </div>
          );
        })}
      </section>
      <div
        onClick={() => {
          handleLogoutUser();
        }}
        className={`text-light-gray py-[10px] px-[12px] flex items-center justify-start hover:text-black font-semibold hover:bg-[#FFFFFF] md:bg-transparent rounded-lg cursor-pointer`}
      >
        <span className="text-main-color">{i18n("logout")}</span>
      </div>
      {cachePop && <CachePop />}
    </motion.section>
  );
};

export default Aside;
